export default __webpack_public_path__ + "static/media/Net2panel.baf99293.png";